export enum authComponentType {
  Login = 'login',
  Signup = 'signup',
  ResetPassword = 'resetpassword',
  SetNewPassword = 'setnewpassword',
}
